<template>
    <div class="serial">
        <serial-box ref="serialBox" class="mb-3" :box-like="false" :can-edit="false" :parent-document-object="parentDocumentObject" :serial-id="serialObject['serial_id']">
            <template v-slot:headerTools>
                <div>
                    <button @click="viewInSerialManager">View in Serial Manager</button>
                </div>
            </template>
        </serial-box>
<!--        <button v-if="inEditWorkMode" class="button-primary edit-involved-button" @click="appendEvent">Add an Event</button>-->
    </div>
</template>

<script>
    import {userSettingsManager, workModeEdit, workModeRead} from "@/utils";
    import SerialBox from "@/components/SerialBox";

    export default {
        name: "DTSerial",
        components: {SerialBox,},
        props: {
            serialObject: Object,
            canEdit: Boolean,
            parentDocumentObject: Object,
        },
        methods: {
            viewInSerialManager() {
                this.$emit('viewInSerialManager', this.serialObject['serial_id']);
            },
            appendEvent() {
                this.$emit('appendEvent', this.serialObject);
            },
            reload() {
                this.$refs.serialBox.findSerial();
            },
        },
        computed: {
            workMode() {
                return userSettingsManager.getWorkMode();
            },
            inEditWorkMode() {
                return this.workMode === workModeEdit;
            },
            inReadWorkMode() {
                return this.workMode === workModeRead;
            },
        }
    }
</script>

<style scoped lang="scss">
    .serial {
        height: 100%;
    }

    .properties {
        margin-bottom: 1.5rem;
        font-size: 14px;

        .label {
            color: gray;
            font-weight: 500;
        }
    }
</style>
